import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function WithActions() {
  return (
    <Section data-test="next-actions-section">
      <SectionHeader>
        <SectionTitle>Action items</SectionTitle>
      </SectionHeader>
      <ul className="m-0 list-inside list-disc pl-2">
        <li className="text-sm font-medium">Send a follow-up email</li>
        <li className="text-sm font-medium">Schedule a demo next week</li>
        <li className="text-sm font-medium">Share the pricing deck</li>
      </ul>
    </Section>
  );
}

function NoActions() {
  return (
    <Section data-test="next-actions-section">
      <SectionHeader>
        <SectionTitle>Action items</SectionTitle>
      </SectionHeader>
      <p className="text-xs font-normal text-muted-foreground">
        No action items were detected on this call.
      </p>
    </Section>
  );
}

function NotProcessed() {
  return (
    <Section data-test="next-actions-section">
      <SectionHeader>
        <SectionTitle>Action items</SectionTitle>
      </SectionHeader>
      <p
        className="text-xs font-normal text-muted-foreground"
        data-test="no-actions-generated"
      >
        Action items could not be generated for this call.
      </p>
    </Section>
  );
}

export function PlaygroundSectionNextActions() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>With actions</PlaygroundSubSectionTitle>
        <WithActions />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>No actions</PlaygroundSubSectionTitle>
        <NoActions />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Not processed</PlaygroundSubSectionTitle>
        <NotProcessed />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
